import React, { useEffect } from "react";
import { RouteComponentProps, Router } from "@reach/router";

import { initializeUser } from "services/analytics";
import NotFound from "pages/not-found";
import { Viewer } from "components/auth/types";
import { authorizeForRole, Roles } from "components/auth/authorize-for-role";
import { MainLayout } from "pages/Layouts";
import { useAppliedPropertyFeature } from "components/feature";
import { Feature } from "types/gql-types";
import Interests from "./interests/list";
import InterestsUpdate from "./interests/update";

import DocumentList from "./documents";
import Document from "./documents/document";
import DocumentUpload from "./documents/upload";

import SettingsPage from "./settings";


interface Props { viewer: Viewer; }

const ClientDashboard: React.FC<RouteComponentProps<Props>> = ({ viewer }) => {
  const userProfileFeatureEnabled = useAppliedPropertyFeature(Feature.USER_PROFILE);
  if (!viewer) return null;
  useEffect(() => {
    const { id: userId, email, fullName, roles: rawRoles, organizationId, properties } = viewer;
    const { id: propertyId, name: propertyName } = properties[0] || {};


    if (userId && email && rawRoles) {
      const roles = Object.values(rawRoles || [""]);
      initializeUser({
        userId,
        fullName: fullName || "",
        roles,
        email,
        organizationId: organizationId || "",
        propertyId: propertyId || "",
        propertyName: propertyName || "",
      });
    }
  }, []);


  return (
    <MainLayout backgroundColor="gray" showHeader>
      <Router primary={false}>
        <Interests path="submissions" />
        <InterestsUpdate path="submissions/:interestListId/:interestId" />

        <DocumentList path="documents" />
        <DocumentUpload path="documents/upload" />
        <Document path="documents/:id" />


        {userProfileFeatureEnabled && (
          <SettingsPage path="settings/*" viewer={viewer} />)}

        <NotFound default />
      </Router>
    </MainLayout>
  );
};

export default authorizeForRole([Roles.Client], ClientDashboard);
